<p-popover #routeFilterPanel>
  <div style="min-width: 240px;">

    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
      <span class="fw-semibold">Routes Filter</span>
    </div>

    <div *ngIf="isLoadingRoutes" class="px-3 py-4 text-center">
      <div class="fw-semibold">Loading routes...</div>
      <div class="mt-2 text-muted small">Preparing the latest route options for this filter.</div>
    </div>

    <!-- Multiselect -->
    <div *ngIf="!isLoadingRoutes" class="px-3 mt-4 pb-1">
      <p-multiSelect
        [options]="routeFilterOptions"
        [(ngModel)]="selectedRoutes"
        optionLabel="label"
        optionValue="value"
        optionDisabled="disabled"
        placeholder="Select routes"
        [style]="{'width':'100%'}"
        [showToggleAll]="false"
        selectedItemsLabel="{0} route(s) selected"
        (onChange)="OnRouteFilterSelect()"
        >
      </p-multiSelect>
    </div>

    <!-- Footer actions -->
    <div *ngIf="!isLoadingRoutes" class=" px-3 mt-4 py-2 border-top mt-1">
      <button class="pn-button pn-button-primary pn-button-md me-2" (click)="applyFilter()">Apply</button>
      <button type="button" class="pn-button pn-button-tertiary pn-button-md" (keydown.enter)="onReset()" (click)="onReset()">Reset</button>
    </div>

  </div>
</p-popover>
